import React from 'react';
import { Router, BrowserRouter } from 'react-router-dom';

import Routes from './routes';
import history from './services/history';

import GlobalStyle from './styles/global';

function App() {
  return (
    <BrowserRouter history={history}>
      <Routes />
      <GlobalStyle />
    </BrowserRouter>
  );
}

export default App;
